"use client";

import { Typography } from "@material-tailwind/react";
import { StarIcon } from "@heroicons/react/24/solid";
import SkillCard from "./SkillCard";

const SKILLS = [
  {
    icon: StarIcon,
    title: "ประกัน PA",
    children: "รับประกันอุบัติเหตุ ฟรี 1 ปี ความคุ้มครองเริ่มต้นที่ 1 แสนบาท",
  },
  {
    icon: StarIcon,
    title: "ราคาถูกดี",
    children: "ซื้อประกันภัยทุกประเภท ทุกบริษัทประกันภัย ในราคาสมาชิก",
  },
  {
    icon: StarIcon,
    title: "ซื้อถูกทั้งบ้าน",
    children:
      "บุคคลในครอบครัวที่นามสกุลเดียวกับสมาชิก ซื้อสินค้าประกันภัยในราคาสมาชิกทั้งครอบครัว",
  },
  {
    icon: StarIcon,
    title: "อายุตลอดชีพ",
    children:
      "ซื้อสินค้าประกันภัยในทุกปีก่อนอายุสมาชิกจะหมด ไม่ต้องเสียค่าสมัครสมาชิกอีกครั้ง",
  },
  {
    icon: StarIcon,
    title: "ผ่อนบัตรเครดิต",
    children:
      "ซื้อสินค้าประกันภัย ประกันรถยนต์ผ่อนได้ 3 – 6 งวด ดอกเบี้ย 0% แถมยังได้รับเงินคืนเข้าบัญชี",
  },
  {
    icon: StarIcon,
    title: "ผ่อนไม่มีบัตรเครดิต",
    children:
      "ซื้อสินค้าประกันภัย ประกันรถยนต์ผ่อนได้ 3 – 6 งวด ดอกเบี้ย 0% แค่มีบัตรประชาชนใบเดียว แถมยังได้เงินคืนเข้าบัญชี",
  },
  {
    icon: StarIcon,
    title: "ได้ตังค์ด้วย",
    children:
      "แนะนำบอกต่อคนรู้จัก ให้ซื้อสินค้าประกันภัยในราคาสมาชิก รับรายได้ 1 – 6% จากยอดขาย สร้างรายได้ด้วยแผนการตลาด MGM",
  },
  {
    icon: StarIcon,
    title: "ได้ความรู้ด้วย",
    children:
      "เข้าอบรมความรู้คอร์สต่าง ๆ ของบริษัทได้ทุกสาขา เพื่อเตรียมความพร้อม เป็นนายหน้าประกันภัยมืออาชีพในอนาคต",
  },
  {
    icon: StarIcon,
    title: "ส่งถึงที่",
    children:
      "รอรับเอกสารกรมธรรม์อยู่ที่บ้าน อยู่ที่ทำงาน ไม่ต้องเสียเวลาเดินทาง ช่วยคุณลดค่าใช้จ่าย",
  },
];

export function Skills() {
  return (
    <section className="px-8">
      <div className="container mx-auto mb-20 text-center">
        <Typography variant="h2" color="blue-gray" className="mb-4 font-noto">
          9 เหตุผลทำไมต้องเป็น
        </Typography>
        <Typography variant="h2" color="blue-gray" className="mb-4 font-noto">
          สมาชิกศรีกรุงโบรคเกอร์
        </Typography>
      </div>
      <div className="container mx-auto grid grid-cols-1 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
        {SKILLS.map((props, idx) => (
          <SkillCard key={idx} {...props} />
        ))}
      </div>
    </section>
  );
}

export default Skills;
